import { axiosClient } from "../api/axiosClient";

export interface NotificationPreferenceView {
  email: boolean;
  push: boolean;
  sms: boolean;
  inApp: boolean;
  whatsapp: boolean;
  typePreferences: Array<{
    type: string;
    push: boolean;
  }>;
}

export const notificationPreferenceRepository = {
  async get(): Promise<NotificationPreferenceView> {
    const { data } = await axiosClient.get<NotificationPreferenceView>(
      "/notification-preferences",
    );
    return data;
  },

  async updateChannels(settings: Partial<NotificationPreferenceView>) {
    const { data } = await axiosClient.patch<NotificationPreferenceView>(
      "/notification-preferences/channels",
      settings,
    );
    return data;
  },

  async updateTypePreference(type: string, push: boolean) {
    const { data } = await axiosClient.patch<NotificationPreferenceView>(
      `/notification-preferences/types/${type}`,
      { push },
    );
    return data;
  },
};
